module.exports = __webpack_public_path__ + "img/ncafe.07ea8605.png";